module.exports = __webpack_public_path__ + "static/media/addressproof.143daf71.png";